import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=853f747e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=853f747e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853f747e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('853f747e')) {
      api.createRecord('853f747e', component.options)
    } else {
      api.reload('853f747e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=853f747e&scoped=true&", function () {
      api.rerender('853f747e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4p7CN6WJbHERt/JS/comp/SearchFilterTokens.vue"
export default component.exports